import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import ColorRowPreview from '../_components/ColorRowPreview'
import type { ColorTileOption } from '../_components/ColorRowPreview/ColorRowPreview'

const useStyles = makeStyles<Theme, FinestWhitesProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'FinestWhites' }
)

export interface FinestWhitesProps {
  classes?: StyleClasses<typeof useStyles>
}

function FinestWhites(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ColorRowPreview
        title="Our Finest Whites"
        description="Clean and bright, white paints can add lightness to any space."
        colorTileOptions={finestWhites}
        links={[
          {
            href: 'https://samples.sherwin-williams.com/?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=samples-color-chips',
            label: 'Order Free Chips',
            theme: 'dark'
          },
          {
            href: 'https://www.sherwin-williams.com/en-us/color/color-family/white-paint-colors?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=color-family-white',
            label: 'View All Whites',
            theme: 'dark'
          }
        ]}
        style={{ padding: '40px 40px 80px' }}
      />
    </div>
  )
}

export default FinestWhites

const finestWhites: ColorTileOption[] = [
  {
    colorTile: {
      color: '#EDEAE0',
      colorCode: '7008',
      colorName: 'Alabaster',
      tall: true,
      darkText: true
    }
  },
  {
    colorTile: {
      color: '#EDECE6',
      colorCode: '7005',
      colorName: 'Pure White',
      tall: true,
      darkText: true
    }
  },
  {
    colorTile: {
      color: '#EDEAE5',
      colorCode: '7004',
      colorName: 'Snowbound',
      tall: true,
      darkText: true
    }
  },
  {
    colorTile: {
      color: '#EEEFEA',
      colorCode: '7006',
      colorName: 'Extra White',
      tall: true,
      darkText: true
    }
  },
  {
    colorTile: {
      color: '#F0EADC',
      colorCode: '6385',
      colorName: 'Dover White',
      tall: true,
      darkText: true
    }
  },
  {
    colorTile: {
      color: '#E3E4E1',
      colorCode: '6252',
      colorName: 'Ice Cube',
      tall: true,
      darkText: true
    }
  }
]
